<!-- src\components\locales\PlanoLocalView.vue -->
<template>
    <div v-if="tienePlano" class="bg-white rounded-xl shadow-sm border border-gray-200 m-1 mt-5 overflow-hidden">

        <div @click="seccionExpandida = !seccionExpandida" class="flex justify-between items-center p-4 bg-gray-50/50 cursor-pointer hover:bg-gray-100 transition-colors">
            <h3 class="text-lg font-semibold text-gray-800">
                {{ modoVista === 'temperatura' ? 'Temperaturas por Zona Interior' : 'Operatividad por Zona Interior' }}
            </h3>

            <div class="flex items-center space-x-4">
                <div @click.stop class="flex items-center bg-gray-200 rounded-lg p-1">
                    <button @click="modoVista = 'temperatura'" :class="modoVista === 'temperatura' ? 'bg-white shadow text-gray-800' : 'text-gray-500 hover:text-gray-700'" class="px-3 py-1.5 text-xs font-semibold rounded-md transition-all">
                        Temperatura
                    </button>
                    <button @click="modoVista = 'operatividad'" :class="modoVista === 'operatividad' ? 'bg-white shadow text-gray-800' : 'text-gray-500 hover:text-gray-700'" class="px-3 py-1.5 text-xs font-semibold rounded-md transition-all">
                        Operatividad
                    </button>
                </div>

                <svg :class="['w-5 h-5 text-gray-500 transition-transform duration-300', seccionExpandida ? 'rotate-180' : '']" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
            </div>
        </div>

        <div class="m-4 mt-2">
            <div v-if="modoVista === 'temperatura'" class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div class="bg-white rounded-lg p-4 border border-efintelwhite-55">
                    <div class="flex items-center space-x-2 mb-1">
                        <svg class="w-5 h-5 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19c-1.657 0-3-1.343-3-3 0-1.127.625-2.11 1.5-2.625V5a2.5 2.5 0 015 0v8.375c.875.515 1.5 1.498 1.5 2.625 0 1.657-1.343 3-3 3z" />
                        </svg>
                        <p class="text-xs font-medium text-gray-500 uppercase tracking-wider">Temperatura Promedio Sala</p>
                    </div>
                    <div class="flex items-baseline space-x-1">
                        <span class="text-2xl font-bold" :style="{ color: obtenerColorTemperaturaTexto(metricasLocal.promedio) }">
                            {{ metricasLocal.promedio !== null ? metricasLocal.promedio.toFixed(1) : '--' }}
                        </span>
                        <span class="text-sm font-medium text-gray-500">°C</span>
                    </div>
                </div>

                <div class="bg-white rounded-lg p-4 border border-efintelwhite-55">
                    <div class="flex items-center space-x-2 mb-1">
                        <svg class="w-5 h-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19c-1.657 0-3-1.343-3-3 0-1.127.625-2.11 1.5-2.625V5a2.5 2.5 0 015 0v8.375c.875.515 1.5 1.498 1.5 2.625 0 1.657-1.343 3-3 3z" />
                        </svg>
                        <p class="text-xs font-medium text-gray-500 uppercase tracking-wider">T° más Alta</p>
                    </div>
                    <div class="flex items-baseline space-x-1">
                        <span class="text-2xl font-bold text-gray-900">
                            {{ metricasLocal.maxima !== null ? metricasLocal.maxima.toFixed(1) : '--' }}
                        </span>
                        <span class="text-sm font-medium text-red-500">°C</span>
                    </div>
                </div>

                <div class="bg-white rounded-lg p-4 border border-efintelwhite-55">
                    <div class="flex items-center space-x-2 mb-1">
                        <svg class="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19c-1.657 0-3-1.343-3-3 0-1.127.625-2.11 1.5-2.625V5a2.5 2.5 0 015 0v8.375c.875.515 1.5 1.498 1.5 2.625 0 1.657-1.343 3-3 3z" />
                        </svg>
                        <p class="text-xs font-medium text-gray-500 uppercase tracking-wider">T° más Baja</p>
                    </div>
                    <div class="flex items-baseline space-x-1">
                        <span class="text-2xl font-bold text-gray-900">
                            {{ metricasLocal.minima !== null ? metricasLocal.minima.toFixed(1) : '--' }}
                        </span>
                        <span class="text-sm font-medium text-blue-500">°C</span>
                    </div>
                </div>
            </div>

            <div v-else class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div class="bg-white rounded-lg p-4 border border-efintelwhite-55">
                    <div class="flex items-center space-x-2 mb-1">
                        <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p class="text-xs font-medium text-gray-500 uppercase tracking-wider">Operatividad Promedio</p>
                    </div>
                    <div class="flex items-baseline space-x-1">
                        <span class="text-2xl font-bold" :style="{ color: metricasOperatividad.promedio === '--' ? '#6B7280' : obtenerColorTextoOperatividadDePorcentaje(metricasOperatividad.promedio) }">
                            {{ metricasOperatividad.promedio }}
                        </span>
                        <span class="text-sm font-medium text-gray-500">%</span>
                    </div>
                </div>

                <div class="bg-white rounded-lg p-4 border border-efintelwhite-55">
                    <div class="flex items-center space-x-2 mb-1">
                        <svg class="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p class="text-xs font-medium text-gray-500 uppercase tracking-wider">Mejor Estado</p>
                    </div>
                    <div class="flex items-baseline space-x-1">
                        <span class="text-2xl font-bold text-gray-900">
                            {{ metricasOperatividad.maxima }}
                        </span>
                        <span class="text-sm font-medium text-green-600">%</span>
                    </div>
                </div>

                <div class="bg-white rounded-lg p-4 border border-efintelwhite-55">
                    <div class="flex items-center space-x-2 mb-1">
                        <svg class="w-5 h-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p class="text-xs font-medium text-gray-500 uppercase tracking-wider">Peor Estado</p>
                    </div>
                    <div class="flex items-baseline space-x-1">
                        <span class="text-2xl font-bold text-gray-900">
                            {{ metricasOperatividad.minima }}
                        </span>
                        <span class="text-sm font-medium text-red-600">%</span>
                    </div>
                </div>
            </div>

            <div v-show="seccionExpandida" class="transition-all duration-300 mt-4">
                <div class="w-full relative rounded-lg bg-gray-50/30">
                    <div v-if="planoBase && !cargando" class="flex flex-col lg:flex-row gap-4 p-2 sm:p-4">

                        <div class="flex-1 flex justify-center rounded-lg overflow-x-auto custom-scrollbar relative border border-gray-200 bg-white">
                            <div ref="contenedorPlano" class="relative inline-block max-w-full overflow-hidden bg-white" @dragover.prevent @drop="alSoltarDispositivo">
                                <img :src="planoBase.archivo_url" class="block w-auto h-auto max-w-full max-h-[700px] object-contain select-none pointer-events-none" alt="Plano del local" @load="recalcularDimensiones" />

                                <div v-for="posicion in posicionesLocal" :key="posicion.id" class="absolute cursor-move transform -translate-x-1/2 -translate-y-1/2 z-10 transition-all duration-200" :style="{ left: obtenerPosicionLeft(posicion.columna) + 'px', top: obtenerPosicionTop(posicion.fila) + 'px' }" draggable="true" @dragstart="alIniciarArrastre($event, posicion)">
                                    <div class="group relative flex flex-col items-center">
                                        <div class="w-10 h-10 bg-white rounded-full flex items-center justify-center overflow-hidden hover:scale-110 transition-transform cursor-grab active:cursor-grabbing border-2" :style="{ borderColor: '#374151', boxShadow: `0 0 15px 4px ${obtenerColorGlow(posicion)}` }">
                                            <img :src="obtenerUrlImagenDispositivo(posicion.dispositivo)" @error="alFallarImagen" class="w-full h-full object-cover pointer-events-none" alt="Dispositivo" />
                                        </div>
                                        <div class="absolute top-12 bg-white border border-gray-200 px-2 py-1 rounded shadow-sm text-center whitespace-nowrap pointer-events-none z-30">
                                            <p class="text-xs font-bold text-gray-800">{{ posicion.dispositivo.nombre_dispositivo }}</p>
                                            <p v-if="posicion.dispositivo.ubicacion_dispositivo" class="text-[10px] text-gray-500">{{ posicion.dispositivo.ubicacion_dispositivo }}</p>

                                            <div class="flex items-center justify-center gap-3 mt-1">
                                                <p v-if="modoVista === 'temperatura'" class="text-xs font-bold" :style="{ color: obtenerColorTemperaturaTexto(posicion.dispositivo.overlay?.temperatura_retorno) }">
                                                    {{ posicion.dispositivo.overlay?.temperatura_retorno ?? '--' }}°C
                                                </p>
                                                <p v-else class="text-xs font-bold" :style="{ color: obtenerColorTextoOperatividad(posicion.dispositivo.overlay?.color_operatividad) }">
                                                    {{ posicion.dispositivo.overlay?.porcentaje_operatividad ?? '--' }}%
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="w-full lg:w-64 shrink-0">
                            <div v-if="modoVista === 'temperatura'" class="bg-white p-4 rounded-lg shadow-sm border border-gray-200 flex flex-col items-center h-fit">
                                <span class="text-sm font-bold text-gray-800 mb-4 border-b border-gray-200 w-full text-center pb-2 uppercase">Temperatura</span>
                                <span class="text-[20px] font-bold text-[#991B1B] mb-1">35°C</span>
                                <div class="w-6 h-48 rounded-full border border-gray-300 shadow-inner" style="background: linear-gradient(to bottom, #991B1B 0%, #ef4444 35%, #3b82f6 65%, #a5f3fc 100%);"></div>
                                <span class="text-[20px] font-bold text-[#0891B2] mt-1">0°C</span>
                            </div>

                            <div v-else class="bg-white p-4 rounded-lg shadow-sm border border-gray-200 flex flex-col items-start space-y-3 h-fit">
                                <span class="text-sm font-bold text-gray-800 mb-2 border-b border-gray-200 w-full text-center pb-2 uppercase">Niveles Operatividad</span>
                                <div class="flex items-center gap-2">
                                    <div class="w-4 h-4 rounded-full bg-green-500 shadow-sm"></div><span class="text-xs font-bold text-gray-600">VERDE (≥80%)</span>
                                </div>
                                <div class="flex items-center gap-2">
                                    <div class="w-4 h-4 rounded-full bg-yellow-400 shadow-sm"></div><span class="text-xs font-bold text-gray-600">AMARILLO (60-79%)</span>
                                </div>
                                <div class="flex items-center gap-2">
                                    <div class="w-4 h-4 rounded-full bg-orange-500 shadow-sm"></div><span class="text-xs font-bold text-gray-600">NARANJA (20-59%)</span>
                                </div>
                                <div class="flex items-center gap-2">
                                    <div class="w-4 h-4 rounded-full bg-red-600 shadow-sm"></div><span class="text-xs font-bold text-gray-600">ROJO (&lt;20%)</span>
                                </div>
                                <div class="flex items-center gap-2">
                                    <div class="w-4 h-4 rounded-full bg-gray-400 shadow-sm"></div><span class="text-xs font-bold text-gray-600">GRIS (N/A)</span>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div v-else-if="cargando" class="text-center py-16">
                        <svg class="animate-spin h-8 w-8 text-blue-600 mx-auto mb-4" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        <p class="text-gray-500 font-medium">Cargando plano del local...</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PlanoService from '@/services/locales/plano.js';
import LocalesService from '@/services/locales/locales.js';
import DispositivosService from '@/services/dispositivos/dispositivos.js';
import { sensorMap, getNumber } from '@/services/utils/sensores.js';
import imagenDefault from '@/assets/ImagenDefaultDispositivos.png';
import { toast } from 'vue-sonner';

export default {
    name: 'PlanoLocalView',
    props: {
        localId: {
            type: Number,
            required: true
        },
        equipos: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            cargando: true,
            tienePlano: false,
            seccionExpandida: true,
            planoBase: null,
            posicionesLocal: [],
            modoVista: 'temperatura', // operatividad
            detallesLevantamiento: [],

            metricasLocal: {
                promedio: null,
                maxima: null,
                minima: null
            },

            anchoRenderizado: 0,
            altoRenderizado: 0,
            dispositivoArrastrado: null,
            posicionPrevia: null
        }
    },
    computed: {
        anchoCelda() {
            if (!this.planoBase || !this.planoBase.columnas) return 0;
            return this.anchoRenderizado / this.planoBase.columnas;
        },
        altoCelda() {
            if (!this.planoBase || !this.planoBase.filas) return 0;
            return this.altoRenderizado / this.planoBase.filas;
        },
        metricasOperatividad() {
            const valid = this.posicionesLocal
                .map(p => p.dispositivo.overlay?.porcentaje_operatividad)
                .filter(p => p !== null && p !== undefined && p !== '--');

            if (valid.length === 0) return { promedio: '--', maxima: '--', minima: '--' };
            const suma = valid.reduce((a, b) => a + Number(b), 0);
            return {
                promedio: (suma / valid.length).toFixed(1),
                maxima: Math.max(...valid).toFixed(1),
                minima: Math.min(...valid).toFixed(1)
            };
        }
    },
    watch: {
        localId: {
            immediate: true,
            handler(newId) {
                if (newId) this.inicializarPlano();
            }
        },
        equipos: {
            deep: true,
            handler() {
                if (this.tienePlano) {
                    this.procesarNuevosEquipos();
                    if (this.posicionesLocal.length > 0) {
                        this.sincronizarDatosEquipos();
                    }
                }
            }
        }
    },
    methods: {
        async inicializarPlano() {
            this.cargando = true;
            this.tienePlano = false;

            try {
                this.cargarMetricasSala();
                await this.cargarDetallesOperatividad();

                const dataBase = await PlanoService.obtenerPlanoBase(this.localId);

                this.tienePlano = true;
                this.planoBase = dataBase;
                this.posicionesLocal = dataBase.posiciones || [];

                this.procesarNuevosEquipos();
                if (this.posicionesLocal.length > 0) {
                    this.sincronizarDatosEquipos();
                }

            } catch (error) {
                if (error.message && error.message.includes('404')) {
                    this.tienePlano = false;
                } else {
                    toast.error('Error al cargar el plano base.');
                    console.error(error);
                }
            } finally {
                this.cargando = false;
                if (this.tienePlano) {
                    this.$nextTick(() => this.recalcularDimensiones());
                }
            }
        },

        async cargarMetricasSala() {
            try {
                const localData = await LocalesService.obtenerLocalPorId(this.localId);
                this.metricasLocal.promedio = localData.temperatura_interior ?? null;
                this.metricasLocal.maxima = localData.max_temperatura_interior ?? null;
                this.metricasLocal.minima = localData.min_temperatura_interior ?? null;
            } catch (error) {
                console.error('Error obteniendo métricas de la sala', error);
            }
        },

        async cargarDetallesOperatividad() {
            try {
                this.detallesLevantamiento = await DispositivosService.obtenerDetallesLevantamiento();
            } catch (error) {
                console.error('Error obteniendo detalles de operatividad', error);
                this.detallesLevantamiento = [];
            }
        },

        procesarNuevosEquipos() {
            if (!this.planoBase || !this.equipos || this.equipos.length === 0) return;
            const dispositivosSinPosicion = this.equipos.filter(disp =>
                !this.posicionesLocal.some(pos => String(pos.dispositivo.id) === String(disp.id))
            );

            if (dispositivosSinPosicion.length > 0) {
                let columnaActual = 1;
                let filaActual = 1;

                const nuevasPosiciones = dispositivosSinPosicion.map(disp => {
                    const nuevaPos = {
                        id: `temp-${disp.id}`,
                        fila: filaActual,
                        columna: columnaActual,
                        dispositivo: {
                            id: disp.id,
                            nombre_dispositivo: disp.nombre_dispositivo || disp.nombre || 'Equipo',
                            ubicacion_dispositivo: disp.ubicacion_dispositivo || disp.zona || '',
                            media_url: disp.media_url || disp.imagen || null
                        }
                    };

                    columnaActual++;
                    if (columnaActual > this.planoBase.columnas) {
                        columnaActual = 1;
                        filaActual++;
                    }
                    return nuevaPos;
                });

                this.posicionesLocal = [...this.posicionesLocal, ...nuevasPosiciones];
            }
        },

        sincronizarDatosEquipos() {
            this.posicionesLocal = this.posicionesLocal.map(pos => {
                const dispCompleto = this.equipos.find(d => String(d.id) === String(pos.dispositivo.id));
                const detalleOp = this.detallesLevantamiento.find(d => String(d.dispositivo) === String(pos.dispositivo.id));

                let temperaturaFinal = null;

                if (dispCompleto) {
                    const mapaSensores = sensorMap(dispCompleto);
                    temperaturaFinal = getNumber(
                        mapaSensores,
                        'Temp Retorno',
                        dispCompleto.configuracion_dispositivo?.['Temp Retorno'] ?? null
                    );
                }

                if (typeof temperaturaFinal === 'number') {
                    temperaturaFinal = parseFloat(temperaturaFinal.toFixed(1));
                }

                return {
                    ...pos,
                    dispositivo: {
                        ...pos.dispositivo,
                        overlay: {
                            ...(pos.dispositivo.overlay || {}),
                            temperatura_retorno: temperaturaFinal,
                            porcentaje_operatividad: detalleOp?.porcentaje_operatividad ?? null,
                            color_operatividad: detalleOp?.color_operatividad || 'GRIS'
                        }
                    }
                };
            });
        },

        obtenerColorGlow(posicion) {
            if (this.modoVista === 'temperatura') {
                return this.obtenerColorTemperatura(posicion.dispositivo.overlay?.temperatura_retorno);
            } else {
                return this.obtenerColorHexOperatividad(posicion.dispositivo.overlay?.color_operatividad);
            }
        },

        obtenerColorHexOperatividad(color) {
            const colores = {
                'VERDE': 'rgba(34, 197, 94, 0.8)', // Tailwind green-500
                'AMARILLO': 'rgba(250, 204, 21, 0.8)', // Tailwind yellow-400
                'NARANJA': 'rgba(249, 115, 22, 0.8)', // Tailwind orange-500
                'ROJO': 'rgba(220, 38, 38, 0.8)', // Tailwind red-600
                'GRIS': 'rgba(156, 163, 175, 0.6)' // Tailwind gray-400
            };
            return colores[color ? color.toUpperCase() : 'GRIS'] || colores['GRIS'];
        },

        obtenerColorTextoOperatividad(color) {
            const colores = {
                'VERDE': '#15803d', // green-700
                'AMARILLO': '#a16207', // yellow-700
                'NARANJA': '#c2410c', // orange-700
                'ROJO': '#b91c1c', // red-700
                'GRIS': '#4b5563' // gray-600
            };
            return colores[color ? color.toUpperCase() : 'GRIS'] || colores['GRIS'];
        },

        obtenerColorTextoOperatividadDePorcentaje(porcentaje) {
            const p = parseFloat(porcentaje);
            if (isNaN(p)) return '#4b5563';
            if (p >= 80) return '#15803d'; // Verde
            if (p >= 60) return '#a16207'; // Amarillo
            if (p >= 20) return '#c2410c'; // Naranja
            return '#b91c1c'; // Rojo
        },
        // este metodo es para recargar los datos de la vista operatividad cuando se lance el emit desde su modal
        async actualizarVistaOperatividad() {
            await this.cargarDetallesOperatividad();

            if (this.posicionesLocal.length > 0) {
                this.sincronizarDatosEquipos();
            }
        },

        obtenerColorTemperatura(temp) {
            if (temp === null || temp === undefined || temp === '--') return 'transparent';
            const t = parseFloat(temp);

            if (t === 0) return 'transparent';

            if (t < 20) return 'rgba(165, 243, 252, 0.8)';
            if (t >= 20 && t < 24) return 'rgba(59, 130, 246, 0.7)';
            if (t >= 24 && t < 28) return 'rgba(239, 68, 68, 0.7)';
            return 'rgba(153, 27, 27, 0.9)';
        },

        obtenerColorTemperaturaTexto(temp) {
            if (temp === null || temp === undefined || temp === '--') return '#6B7280';
            const t = parseFloat(temp);

            if (t === 0) return '#000000';

            if (t < 20) return '#0891B2';
            if (t >= 20 && t < 24) return '#1D4ED8';
            if (t >= 24 && t < 28) return '#DC2626';
            return '#991B1B';
        },

        recalcularDimensiones() {
            if (this.$refs.contenedorPlano) {
                this.anchoRenderizado = this.$refs.contenedorPlano.clientWidth;
                this.altoRenderizado = this.$refs.contenedorPlano.clientHeight;
            }
        },

        obtenerPosicionLeft(columna) {
            return (columna - 0.5) * this.anchoCelda;
        },

        obtenerPosicionTop(fila) {
            return (fila - 0.5) * this.altoCelda;
        },

        alIniciarArrastre(evento, posicion) {
            this.dispositivoArrastrado = posicion;
            this.posicionPrevia = { fila: posicion.fila, columna: posicion.columna };
            evento.dataTransfer.effectAllowed = 'move';
            evento.dataTransfer.setDragImage(evento.target, 20, 20);
        },

        async alSoltarDispositivo(evento) {
            if (!this.dispositivoArrastrado || !this.planoBase) return;

            const rect = this.$refs.contenedorPlano.getBoundingClientRect();
            const x = evento.clientX - rect.left;
            const y = evento.clientY - rect.top;

            const columnaCalculada = Math.ceil(x / this.anchoCelda);
            const filaCalculada = Math.ceil(y / this.altoCelda);

            if (
                columnaCalculada >= 1 && columnaCalculada <= this.planoBase.columnas &&
                filaCalculada >= 1 && filaCalculada <= this.planoBase.filas
            ) {
                const index = this.posicionesLocal.findIndex(p => p.id === this.dispositivoArrastrado.id);

                if (index !== -1 && (this.posicionesLocal[index].columna !== columnaCalculada || this.posicionesLocal[index].fila !== filaCalculada)) {

                    this.posicionesLocal[index].columna = columnaCalculada;
                    this.posicionesLocal[index].fila = filaCalculada;

                    await this.guardarLayoutCompleto(index);
                }
            }
            this.dispositivoArrastrado = null;
        },

        async guardarLayoutCompleto(indexModificado) {
            try {
                await PlanoService.guardarPosiciones(this.localId, this.posicionesLocal);
                toast.success('Nueva posición guardada.');
            } catch (error) {
                toast.error('No se pudo guardar la posición. Revirtiendo...');
                if (this.posicionPrevia) {
                    this.posicionesLocal[indexModificado].fila = this.posicionPrevia.fila;
                    this.posicionesLocal[indexModificado].columna = this.posicionPrevia.columna;
                }
            } finally {
                this.posicionPrevia = null;
            }
        },

        obtenerUrlImagenDispositivo(dispositivo) {
            if (!dispositivo) return imagenDefault;

            const ruta = dispositivo.media_url || dispositivo.media || dispositivo.imagen;

            if (!ruta || ruta === 'ImagenDefault') {
                return imagenDefault;
            }

            if (ruta.startsWith('http')) {
                return ruta;
            }

            const baseURL = process.env.VUE_APP_API_URL || 'https://efibox.efintel.cl';
            return `${baseURL}${ruta.startsWith('/') ? ruta : '/' + ruta}`;
        },

        alFallarImagen(evento) {
            evento.target.src = imagenDefault;
        }
    },
    mounted() {
        window.addEventListener('resize', this.recalcularDimensiones);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.recalcularDimensiones);
    }
}
</script>